<template>
  <SplitViewTemplate
    :screenConfig="setScreenConfig"
    :backButtonRoute="'/home'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
    :persistenceKey="'gl-account-list'"
    :customMessages="customMessages"
  />
</template>

<script>
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      formModel: {
        Inactive: true,
        IsPostalData: false,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
        GLGroup2Code: "",
        DateFirstUsed: null,
      },
    };
  },
  computed: {
    customMessages() {
      return {
        success: {
          message: `Account <Code> - <Description> has been successfully created`,
          keys: ["Code", "Description"],
        },
      };
    },
    setScreenConfig() {
      var config = {
        title: "GL Accounts",
        ScreenName: "GL Accounts",
        pageRoute: "/gl-accounts",
        saveEndPoint: "Save_GLChart",
        // updateEndPoint: "GLChart",
        recordEndPoint: "GLChart",

        exportFileName: "GLAccounts",

        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "GLChart",

              filter: "",
              serverPaging: true,
              allowGrouping: false,
              expand: [
                "GLGroup1($select=Code,Description)",
                "GLGroup2($select=Code,Description)",
                "GLGroup3($select=Code,Description)",
                "GLGroup4($select=Code,Description)",
                "GLGroup5($select=Code,Description)",
                "GLGroup6($select=Code,Description)",
                "GLGroup7($select=Code,Description)",
                "GLGroup8($select=Code,Description)",
                "GLGroup9($select=Code,Description)",
                "GLGroup10($select=Code,Description)",
              ],
              postProcessCallback: this.glAccountPostProcess,
              keyType: {
                GLGroup1Code: "String",
                GLGroup2Code: "String",
                GLGroup3Code: "Int32",
                GLGroup4Code: "Int32",
                GLGroup5Code: "Int32",
                GLGroup6Code: "Int32",
                GLGroup7Code: "Int32",
                GLGroup8Code: "Int32",
                GLGroup9Code: "Int32",
                GLGroup10Code: "Int32",
              },
            },

            rowSelect: {
              view: this,
              page: "gl-accounts",
              mode: "review",
              idProperty: "Code",
              idMode: "Guid",
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            openFilterByDefault: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/gl-accounts/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "Account",
              sortOrder: "asc",
              sortIndex: 0,
              // dataField: "Code",
              gridDataField: "ComputedStringCode",
              allowHiding: false,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "Description",
                  },
                ],
                secondary: [
                  {
                    dataField: "Code",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "ComputedStringCode",
                  label: "Account Code",
                  allowSearch: false,
                },
                {
                  dataField: "Description",
                  label: "Account Description",
                },
              ],
              filterIndex: 0,
              filterDataField: "GLAccountSearchText",
              dataType: "string",
              type: "Text",
            },
            {
              screenField: "AccountType",
              dataField: "AccountType",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "AccountTypeDescription",
                  },
                ],
                secondary: [
                  {
                    dataField: undefined,
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "AccountType",
                  allowSearch: false,
                  label: "Account Type Code",
                },
                {
                  dataField: "AccountTypeDescription",
                  label: "Account Type Description",
                  allowSearch: false,
                },
              ],
              filterIndex: 1,
              editorTemplate: {
                primary: [
                  {
                    dataField: "Description",
                  },
                ],
              },
              valueExpr: "Description",
              displayExpr: "Description",
            },
            {
              screenField: "BasCode",
              filterIndex: 2,
            },
            ...this.glGroupColumns,

            {
              screenField: "Status",
              filterIndex: 13,
            },
          ],
        },
      };

      return config;
    },

    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          audit: true,
          save: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: this.setActiveReadOnly,
              },
            },
          ],
          toolbarFormLocation: "after",
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                screenField: "Code",
                dataField: "Code",

                label: {
                  text: "Account",
                },

                validationRules: [
                  {
                    type: "numeric",
                    message: "Account must be a number",
                  },

                  {
                    type: "required",
                    message: "Account is required",
                  },
                ],
                editorOptions: {
                  valueChangeEvent: "keyup",
                  maxLength: 5,
                  value: undefined,
                },
                allowUpdate: this.baseView.mode != "create" ? false : true,
              },

              {
                dataField: "Description",
                label: "Description",
                // required: true,
                visible: true,
                cellTemplate: undefined,
                editorOptions: {
                  maxLength: 35,
                },
                validationRules: [
                  {
                    type: "custom",
                    validationCallback: (e) => {
                      e.rule.message = `Description only allow maximum length of 35 characters`;
                      return e.value.length < 36;
                    },
                  },
                  {
                    type: "required",
                    message: "Description is required",
                  },
                ],
              },
              {
                screenField: "AccountType",
                dataField: "AccountType",
                required: "true",
                // cellTemplate:undefined,
                editorOptions: {
                  readOnly: this.formModel.DateFirstUsed != null,
                },
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Description;
                  else return "";
                },
              },

              {
                screenField: "BasCode",
                required: "true",
                // visible: false,
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Description;
                  else return "";
                },
              },
              {
                screenField: "GLGroup1Code",
                label: {
                  text: "Group 1",
                },
                required: "true",
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Description;
                  else return "";
                },
              },
              {
                screenField: "GLGroup2Code",
                label: {
                  text: "Group 2",
                },
                required: "true",
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Description;
                  else return "";
                },
              },

              {
                screenField: "GLGroup3Code",
                label: {
                  text: "Group 3",
                },
                required: "true",
                editorOptions: {
                  keyType: {
                    CodeComputedString: "String",
                  },
                },
                searchExpr: ["Description", "CodeComputedString"],
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Description;
                  else return "";
                },
                valueExpr: "Code",
              },
              {
                screenField: "GLGroup4Code",
                label: {
                  text: "Group 4",
                },
                required: "true",
                editorOptions: {
                  keyType: {
                    CodeComputedString: "String",
                  },
                },
                searchExpr: ["Description", "CodeComputedString"],
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Description;
                  else return "";
                },
                valueExpr: "Code",
              },
              {
                screenField: "GLGroup5Code",
                label: {
                  text: "Group 5",
                },
                required: "true",
                searchExpr: ["Description", "CodeComputedString"],
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Description;
                  else return "";
                },
                valueExpr: "Code",
              },
              {
                screenField: "GLGroup6Code",
                label: {
                  text: "Group 6",
                },
                required: "true",
                searchExpr: ["Description", "CodeComputedString"],
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Description;
                  else return "";
                },
                valueExpr: "Code",
              },
              {
                screenField: "GLGroup7Code",
                label: {
                  text: "Group 7",
                },
                required: "true",
                searchExpr: ["Description", "CodeComputedString"],
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Description;
                  else return "";
                },
                valueExpr: "Code",
              },
              {
                screenField: "GLGroup8Code",
                label: {
                  text: "Group 8",
                },
                required: "true",
                searchExpr: ["Description", "CodeComputedString"],
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Description;
                  else return "";
                },
                valueExpr: "Code",
              },
              {
                screenField: "GLGroup9Code",
                label: {
                  text: "Group 9",
                },
                required: "true",
                searchExpr: ["Description", "CodeComputedString"],
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Description;
                  else return "";
                },
                valueExpr: "Code",
              },
              {
                screenField: "GLGroup10Code",
                label: {
                  text: "Group 10",
                },
                required: "true",
                searchExpr: ["Description", "CodeComputedString"],
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Description;
                  else return "";
                },
                valueExpr: "Code",
              },
            ],
          },
        ],
      };

      return form;
    },
    setActiveReadOnly() {
      // return this.formModel["SetDefault"] ? true : false;
      return null;
    },

    /*
     * Dynamically generate GL Group columns based on the number of groups (10 in this case).
     * The first 3 groups are visible by default, and the rest are hidden.
     * Numeric type and left alignment are applied to groups greater than 2.
     */
    glGroupColumns() {
      return Array.from({ length: 10 }, (_, i) => {
        const num = i + 1;
        const isNumeric = num > 2;
        const isVisible = num <= 3;

        return {
          screenField: `GLGroup${num}Code`,
          ...(isNumeric && { type: "number", alignment: "left" }),
          ...(!isVisible && { visible: false }),
          exportFields: [
            {
              dataField: `GLGroup${num}.Description`,
              label: `GLGroup ${num} Description`,
            },
            {
              dataField: `GLGroup${num}Code`,
              label: `GLGroup ${num} Code`,
              allowSearch: false,
              alignment: "left",
            },
          ],
          filterIndex: num + 2,
        };
      });
    },
  },
  methods: {
    glAccountPostProcess(data) {
      data.forEach((element) => {
        // GLGroup1Description
        element.GLGroup1Description = element.GLGroup1.Description;
        // element.GLGroup1Code = 1;
        element.GLGroup2Description = element.GLGroup2.Description;
        element.GLGroup3Description = element.GLGroup3.Description;
        element.GLGroup4Description = element.GLGroup4.Description;
        element.GLGroup5Description = element.GLGroup5.Description;
        element.GLGroup6Description = element.GLGroup6.Description;
        element.GLGroup7Description = element.GLGroup7.Description;
        element.GLGroup8Description = element.GLGroup8.Description;
        element.GLGroup9Description = element.GLGroup9.Description;
        element.GLGroup10Description = element.GLGroup10.Description;

        element.AccountTypeCode = element.AccountType;

        if (element.AccountTypeCode == "I") {
          element.AccountTypeDescription = "Income";
        } else if (element.AccountTypeCode == "E") {
          element.AccountTypeDescription = "Expense";
        } else if (element.AccountTypeCode == "A") {
          element.AccountTypeDescription = "Asset";
        } else if (element.AccountTypeCode == "L") {
          element.AccountTypeDescription = "Liability ";
        }
      });

      return data;
    },
  },
};
</script>
